import { DateFormatType } from "../models/date-format.model";

export const dateFormats: DateFormatType = {
  basic: { eu: 'dd/MM/yyyy', us: 'MM/dd/yyyy' },
  short: { eu: 'dd MMM yyyy', us: 'MMM dd, yyyy' },
  dateTimeSec: { eu: 'dd/MM/yyyy, HH:mm:ss', us: 'MM/dd/yyyy, hh:mm:ss a' },
  dateTimeMin: { eu: 'dd/MM/yyyy, HH:mm', us: 'MM/dd/yyyy, hh:mm a' },
  dateTimeTz: { eu: 'dd MMM, HH:mm z', us: 'MMM dd hh:mm A z' },
}